import { DeckEditor } from './DeckEditor';

export default function DeckEditorPage() {
  return <DeckEditor />;
}
